// extracted by mini-css-extract-plugin
export default {"dummyRelativeNew":"L2pWI6","headerContainer":"IPgolA","backButton":"HUbMEl","headerTitle":"TioP9W","headerContentList":"V3dQ2K"};